export enum Category {
    GAMES = 'games',
    ENGINES = 'engines',
    APPLICATIONS = 'applications',
    COLLECTIONS = 'collections',
    DEPRECATED = 'deprecated',
    FREE = 'freegames',
    HIDDEN = 'hidden'
}

export enum CustomProp {
    AVAILABLE_DATE = 'availableDate',
    EXTRA_LAUNCH_OPTION_PREFIX = 'extraLaunchOption',
    EXTRA_LAUNCH_OPTION_NAME_SUFFIX = '_Name',
    EXTRA_LAUNCH_OPTION_ARGS_SUFFIX = '_Args',
    IS_BETA = 'isBeta',
    IS_DEMO = 'isDemo',
    IS_UPLAY = 'isUplay',
    NEVER_UPDATE = 'NeverUpdate',
    PRODUCT_DEVELOPER_NAME = 'developerName',
    PARTNER_LINK_TYPE = 'partnerLinkType',
    PARTNER_LINK_ID = 'partnerLinkId',
    PARENT_PARTNER_LINK_ID = 'parentPartnerLinkId',
    PRODUCT_IS_PRE_PURCHASE = 'isPrepurchase',
    PRODUCT_ORDER_WEIGHT = 'com.epicgames.app.weight',
    PRODUCT_PUBLISHER_NAME = 'publisherName',
    PRODUCT_SLUG = 'com.epicgames.app.productSlug',
    WEB_URL_OVERRIDE = 'com.epicgames.app.webUrlOverride'
}

// Special namespace, productName, and catalog ID for the launcher
export const LAUNCHER = 'EpicGamesLauncher';
export const NAMESPACE_UE = 'ue';

export enum KeyImageType {
    GAMEBOX = 'DieselGameBox',
    GAMEBOX_LOGO = 'DieselGameBoxLogo',
    STORE_FRONT_TALL = 'DieselStoreFrontTall',
    STORE_FRONT_WIDE = 'DieselStoreFrontWide',
    COMING_SOON = 'ComingSoon',
    COMING_SOON_SMALL = 'ComingSoon_Small',
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
    THUMBNAIL = 'Thumbnail',
    ANDROIDICON = 'AndroidIcon',
    FEATURED = 'Featured',
    SCREENSHOT = 'Screenshot'
}

export default {
    categories: Category,
    customProps: CustomProp,
    keyImageTypes: KeyImageType,
    NAMESPACE_UE,
    LAUNCHER
};
